export const divProgressHide = {
    display: 'none'
};
export const divProgressShow = {
    display: 'inline'
};